import { render, staticRenderFns } from "./dataSummary.vue?vue&type=template&id=28576905&scoped=true&"
import script from "./dataSummary.vue?vue&type=script&lang=js&"
export * from "./dataSummary.vue?vue&type=script&lang=js&"
import style0 from "./dataSummary.vue?vue&type=style&index=0&id=28576905&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28576905",
  null
  
)

component.options.__file = "dataSummary.vue"
export default component.exports